module.exports = __webpack_public_path__ + "img/small.e3b37863.jpg";